var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ClientError, GraphQLClient } from 'graphql-request';
export const elevioGraphqlRequestBaseQuery = (options) => {
    const client = 'client' in options ? options.client : new GraphQLClient(options.url);
    if ('requestHeaders' in options) {
        client.setHeaders(options.requestHeaders);
    }
    return ({ document, variables }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            return { data: yield client.request(document, variables), meta: {} };
        }
        catch (error) {
            if (error instanceof ClientError) {
                const { name, message, stack, request, response } = error;
                const errorWithCode = ((_a = response.errors) === null || _a === void 0 ? void 0 : _a.find((err) => err.extensions.code === 'UpgradeRequired')) || ((_b = response.errors) === null || _b === void 0 ? void 0 : _b.find((err) => err.extensions.code));
                const graphQlErrorMessage = errorWithCode === null || errorWithCode === void 0 ? void 0 : errorWithCode.message;
                const graphQlErrorCode = errorWithCode === null || errorWithCode === void 0 ? void 0 : errorWithCode.extensions.code;
                return {
                    error: {
                        name,
                        // Return the graphql message if one exists, otherwise use standard error message
                        message: graphQlErrorMessage || message,
                        stack,
                        code: graphQlErrorCode,
                    },
                    meta: { request, response },
                };
            }
            throw error;
        }
    });
};
